import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Button, Flex, Text } from "pcln-design-system";
import { Map } from "pcln-icons";
import { useContext, useEffect, useState } from "react";
import analytics from "../../analytics/analytics.js";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import { useChatUIContext } from "../../hooks/useChatUIContext.js";
import { inlineMetadataManager } from "../MarkdownComponent/MetadataManager.js";
const OpenMapButton = ({ isLoading, isStandalone, isMobile })=>{
    const { shouldUseMapFeature } = useContext(ChatbotDataContext);
    const hotelOnMapList = inlineMetadataManager.getHotelOnMapList();
    const locationPinList = inlineMetadataManager.getLocationPinList();
    const [hasPinOnMap, setHasPinOnMap] = useState(false);
    const { setIsMapOpened, shouldDisplayMapButton } = useChatUIContext();
    useEffect(()=>{
        const hasPinOnMap = hotelOnMapList?.length > 0 || locationPinList?.length > 0;
        if (hasPinOnMap && isStandalone && !isMobile) setIsMapOpened(true);
        setHasPinOnMap(hasPinOnMap);
    }, [
        isStandalone,
        hotelOnMapList,
        locationPinList,
        setIsMapOpened,
        isMobile
    ]);
    if (!shouldUseMapFeature || !hasPinOnMap || isLoading || !shouldDisplayMapButton) return null;
    return /*#__PURE__*/ jsx(Box, {
        style: {
            position: 'sticky',
            bottom: '16px',
            width: '100%',
            textAlign: 'center',
            zIndex: 1000
        },
        children: /*#__PURE__*/ jsx(Button, {
            size: "small",
            style: {
                boxShadow: '0px 3px 8px 0px #00000029, 0px 2px 2px 0px #0000001F, 0px 0px 2px 0px #00000033, 0px -1px 0px 0px #00000008'
            },
            onClick: function() {
                analytics.fireGA4Event({
                    event: 'map_click',
                    attributes: {
                        type: 'penny',
                        page_name: 'listings',
                        product_name: 'hotel'
                    }
                });
                setIsMapOpened(true);
            },
            title: "Open Map",
            children: /*#__PURE__*/ jsxs(Flex, {
                children: [
                    /*#__PURE__*/ jsx(Map, {
                        color: "lightest",
                        size: 16
                    }),
                    /*#__PURE__*/ jsx(Text, {
                        ml: 1,
                        children: "Map"
                    })
                ]
            })
        })
    });
};
export { OpenMapButton };
